import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import EditIcon from '@mui/icons-material/Edit'
import { XMarkSvg } from '../../../../common/svg/xMark'
import { CheckMarkSvg } from '../../../../common/svg/checkMark'
import { connect } from 'react-redux'
import { getCompCityList, updateModal } from '../../../../../store/common/common_action'
import AutoDeliveryModal from './AutoDeliveryModal'
import * as mdt from '../../../../common/modaltypes'
import { isEmpty } from '../../../../common/helper'
import { getAutoDeliveryTableData } from '../../../../../store/generalSetting/GSAction'
import moment from 'moment'
import { getOwnChildBranches, getOwnChildUsers } from '../../../../../store/reports/reports_action'
import ConfirmModal from './ConfirmModal'
import { useTranslation } from '../../../../../i18n/I18nProvider'
const AutoDeliveryTable = (props) => {
  const { data, updateModal, getAutoDeliveryTableData, getOwnChildBranches, getOwnChildUsers, getCompCityList } = props
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const { common, generalSettingReducer, reports } = data
  const { loginData, roleRights, showModal, modalType, companyCityList } = common
  const { ownChildBranches, ownChildUsers } = reports
  const { autoDeliveryTblData } = generalSettingReducer
  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('')
  const [tableData, setTableData] = useState([])
  const [editData, setEditData] = useState()
  // const dataA = {
  //   fromCity: 'Bangalore',
  //   fromBranch: 'Bangalore Cargo Office',
  //   fromUser: 'Krishna Pandey',
  //   afterDays: '2 Days',
  //   hrs: '5 Hours',
  //   min: '20 Minutes',
  //   status: true,
  //   modifiedBy: 'Kirtan Pandya',
  //   dateTime: '9:30, 4-Dec-23',
  // }
  useEffect(() => {
    getTableData()
  }, [loginData])
  useEffect(() => {
    //branchList
    if (!isEmpty(loginData)) {
      const branchData = {
        intUserID: 0,
        intCompanyID: loginData?.intCompanyID,
        intIsActive: 1,
      }
      getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)

      //userList
      const userData = {
        intCompanyID: loginData.intCompanyID,
        intIsActive: 1,
      }
      getOwnChildUsers(userData, true, 24 * 60 * 60 * 1000)
      //cityList
      const cityObj = {
        intCompanyID: loginData.intCompanyID,
        intBranchID: 0,
        intUserID: 0,
      }
      getCompCityList(cityObj, true, 24 * 60 * 60 * 1000)
    }
  }, [loginData])
  const getTableData = () => {
    if (!isEmpty(loginData)) {
      let object = {
        CompanyID: loginData?.intCompanyID,
      }
      getAutoDeliveryTableData(object)
    }
  }
  useEffect(() => {
    if (autoDeliveryTblData?.length > 0) {
      const data = [...autoDeliveryTblData]
      setTableData(data)
    } else {
      setTableData([])
    }
  }, [autoDeliveryTblData])
  const columnDefs = [
    {
      headerName: tr('gsSN', 'SN'),
      headerSx: { padding: '6px 12px', textAlign: 'right', minWidth: '2%' },
      field: 'SN',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
    {
      headerName: tr('atAdByCity', 'Auto Delivery\n By City'),
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '9%' },
      field: 'packingName',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('atAdByBranch', 'Auto Delivery\n By Branch'),
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '12%' },
      field: 'UserModified',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('atAdByUser', 'Auto Delivery\n By User'),
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '12%' },
      field: 'ModifiedDate',
      dataType: 'time',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('atAdAfterDays', 'Auto Delivery\n After Days'),
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '8%' },
      field: 'active',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('atAdAfterHours', 'Auto Delivery\n After Hours'),
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '8%' },
      field: 'Edit',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('atAdAfterMinutes', 'Auto Delivery\n After Minutes'),
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '8%' },
      field: 'Edit',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },

    {
      headerName: tr('gsStatus', 'Status'),
      headerSx: { padding: '6px 12px', textAlign: 'center', minWidth: '5%' },
      field: 'Edit',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
    {
      headerName: tr('atModByUser', 'Modified By\n User'),
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '12%' },
      field: 'Edit',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('atModDateTime', 'Modified Date\n and Time'),
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '9%' },
      field: 'Edit',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
    {
      headerName: tr('gsEdit', 'Edit'),
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '4%' },
      field: 'Edit',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
  ]
  const EmptyTableRow = () => {
    return (
      <TableRow>
        <TableCell colSpan={12}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '15px',
              marginBottom: '15px',
              color: 'red',
              fontSize: '14px',
            }}
          >
            <span>{tr('noResultsSelectedFilters', 'No results found for the selected filters.')}</span>
          </div>
        </TableCell>
      </TableRow>
    )
  }
  const AutoTransRecvRow = (props) => {
    const { item, index } = props
    return (
      <TableRow key={`auto-trans-recv-${index}`} style={{ minHeight: '40px' }}>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '2%', padding: '4px 12px', textAlign: 'right' }}>
          {index + 1}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '9%', padding: '4px 12px' }}>
          {item.CityName}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '12%', padding: '4px 12px' }}>
          {item.BranchName}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '12%', padding: '4px 12px' }}>
          {item.UserName}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '8%', padding: '4px 12px' }}>
          {item.Days}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '8%', padding: '4px 12px' }}>
          {item.Hours}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '8%', padding: '4px 12px' }}>
          {item.Minutes}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '5%', padding: '4px 12px', textAlign: 'center' }}>
          {item.IsActive ? (
            <span>
              <CheckMarkSvg />
            </span>
          ) : (
            <span>
              <XMarkSvg />
            </span>
          )}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '12%', padding: '4px 12px' }}>
          {item.ModifiedByUser}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '9%', padding: '4px 12px' }}>
          {moment(item.ModifiedDateTime).format('HH:mm, DD-MMM-YY')}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '4%', padding: '4px 12px' }}>
          <span
            id={`editBtn-${index}`}
            tabIndex={0}
            style={{
              display: 'flex',
              color: '#007bfd',
              fontSize: '13px',
              fontWeight: 'bold',
              width: '52px',
              padding: '2px 4px',
              marginLeft: '-6px',
            }}
            onClick={() => {
              setEditData(item)
              updateModal(true, mdt.AutoDeliveryEdit)
            }}
          >
            <EditIcon sx={{ marginRight: '3px' }} />
            {tr('gsEdit', 'Edit')}
          </span>
        </TableCell>
      </TableRow>
    )
  }
  return (
    <>
      <Stack style={{ padding: '5px 0px' }}>
        <Button
          id="mopAddBtn"
          style={{ margin: '0', height: '40px', width: '310px' }}
          className="btn add-btn"
          variant="contained"
          color="error"
          // onClick={() => { handleAdd() }}
          // onKeyDown={(e) => {
          //     navigation1(e, `editBtn-0`, 'mopActive');
          // }}
          onClick={() => {
            updateModal(true, mdt.AutoDeliveryCreate)
          }}
        >
          {tr('atCreateNewAd', '+ create new Auto Delivery')}
        </Button>
      </Stack>
      <Stack style={{ maxHeight: '60vh', marginTop: '7px' }}>
        <TableContainer
          className="lr-popup-table lrModel  scrollBlue"
          style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px' }}
          component={Paper}
        >
          <Table
            style={{ border: 'none', overflow: 'auto' }}
            stickyHeader
            id="focApprovalTbl"
            className="table1 table-Received "
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
              <TableRow key="foc-tbl-header" style={{ background: '#d9edff' }}>
                {columnDefs.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    style={{
                      ...col.headerSx,
                      verticalAlign: 'top',
                      backgroundColor: '#DAEDFE',
                      minHeight: '40px',
                      fontFamily: 'Roboto',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444444',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      {col.headerName.split('\n').map((line, lineIndex) => (
                        <span key={`line-${lineIndex}`} style={{}}>
                          {line}
                        </span>
                      ))}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                {columnDefs.map((col, index) =>
                  col.showfilter ? (
                    <TableCell key={`FTH-${index}`} style={{ padding: '6px 6px' }}>
                      <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                        <input
                          id={`index-${index}`}
                          className="field"
                          name="cancelSearchInput"
                          style={{ width: '100%', height: '24px' }}
                          placeholder={tr('gsContains', 'Contains')}
                        // onChange={(e) => handleSearchData(e, col.field)}
                        // onKeyDown={(e) => keyboardNavigation(e, index === 1 ? `Edit-${showTableData?.length - 1}` : `index-${index - 1}`, index === 10 ? 'Edit-0' : `index-${index + 1}`)}
                        />
                        <FilterAltIcon style={{ color: '#aaa' }} />
                      </div>
                    </TableCell>
                  ) : (
                    <TableCell></TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            {tableData?.length > 0 ? (
              <>
                <TableBody className="filter-data-row" style={{ border: 'none' }}>
                  {tableData?.map((item, index) => (
                    <AutoTransRecvRow item={item} index={index} key={index} />
                  ))}
                </TableBody>
              </>
            ) : (
              <>
                <TableBody>
                  <EmptyTableRow />
                </TableBody>
              </>
            )}
          </Table>
        </TableContainer>
      </Stack>
      {showModal && mdt.AutoDeliveryCreate === modalType ? (
        <AutoDeliveryModal
          getTableData={getTableData}
          branchList={ownChildBranches}
          userList={ownChildUsers}
          cityList={companyCityList}
          updateModal={updateModal}
          headTxt={tr('atCreateAdConfig', 'Create Auto Delivery Configuration')}
          isUpdate={false}
        />
      ) : null}
      {showModal && mdt.AutoDeliveryEdit === modalType ? (
        <AutoDeliveryModal
          getTableData={getTableData}
          branchList={ownChildBranches}
          userList={ownChildUsers}
          cityList={companyCityList}
          updateModal={updateModal}
          headTxt={tr('atEditAdConfig', 'Edit Auto Delivery Configuration')}
          isUpdate={true}
          editData={editData}
        />
      ) : null}
      {showModal && mdt.autoDeliveryConfModal === modalType ? <ConfirmModal updateModal={updateModal} /> : null}
    </>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, getAutoDeliveryTableData, getOwnChildBranches, getOwnChildUsers, getCompCityList }
export default connect(mapStateToProps, mapDispatchToProps)(AutoDeliveryTable)
